import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { API_HOST } from '../../../environments/environment';
import { LinkedAccountsDialogComponent } from './dialogs/linked-accounts-dialog.component';

interface OtherStatsResponse {
  webNotificationsCount: number;
  mobileNotificationsCount: number;
  linkedAccountsGroupsCount: number;
  linkedAccountsGroups: { users: { id: string; email: string }[] }[];
}

@Component({
  selector: 'app-other-statistics',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatDialogModule],
  templateUrl: './other-statistics.component.html',
  styleUrls: ['./other-statistics.component.scss']
})
export class OtherStatisticsComponent implements OnInit {
  stats: OtherStatsResponse | null = null;
  loading = true;

  constructor(private http: HttpClient, private dialog: MatDialog) {}

  openLinkedAccountsDialog() {
    if (!this.stats || !this.stats.linkedAccountsGroups) return;
    this.dialog.open(LinkedAccountsDialogComponent, {
      width: '600px',
      data: { groups: this.stats.linkedAccountsGroups },
      panelClass: 'dialog-no-padding'
    });
  }

  ngOnInit(): void {
    this.http.get<OtherStatsResponse>(`${API_HOST}admin/statistics/other`).subscribe({
      next: (data) => {
        this.stats = data;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }
}
